import request from '@/utils/request'

export function sApi(url, data) { return request({ url, data }) }

export default sApi